export default function flippedReversedTransform(input) {
  return input
    .replace(/A/gi, "ɐ")
    .replace(/B/gi, "¨")
    .replace(/C/gi, "ɔ")
    .replace(/D/gi, "ρ")
    .replace(/E/gi, "ǝ")
    .replace(/F/gi, "ɟ")
    .replace(/G/gi, "פ")
    .replace(/H/gi, "ɥ")
    .replace(/I/gi, "ı")
    .replace(/J/gi, "ɾ")
    .replace(/K/gi, "ʞ")
    .replace(/L/gi, "ן")
    .replace(/M/gi, "ɯ")
    .replace(/N/gi, "ʋ")
    .replace(/O/gi, "o")
    .replace(/P/gi, "d")
    .replace(/Q/gi, "b")
    .replace(/R/gi, "ɹ")
    .replace(/S/gi, "s")
    .replace(/T/gi, "ʇ")
    .replace(/U/gi, "n")
    .replace(/V/gi, "ʌ")
    .replace(/W/gi, "ʍ")
    .replace(/X/gi, "x")
    .replace(/Y/gi, "ʎ")
    .replace(/Z/gi, "z")
    .replace(/¨/gi, "q")
    .replace(/á/gi, "ɐ")
    .replace(/â/gi, "ɐ")
    .replace(/ã/gi, "ɐ")
    .replace(/é/gi, "ǝ")
    .replace(/ê/gi, "ǝ")
    .replace(/í/gi, "ı")
    .replace(/ó/gi, "o")
    .replace(/ô/gi, "o")
    .replace(/õ/gi, "o")
    .replace(/ú/gi, "n")
    .replace(/Á/gi, "ɐ")
    .replace(/Â/gi, "ɐ")
    .replace(/Ã/gi, "ɐ")
    .replace(/É/gi, "ǝ")
    .replace(/Ê/gi, "ǝ")
    .replace(/Í/gi, "ı")
    .replace(/Ó/gi, "o")
    .replace(/Ô/gi, "o")
    .replace(/Õ/gi, "o")
    .replace(/Ú/gi, "n")
    .split("")
    .reverse()
    .join("")
    .replace(/ /gi, "ㅤ");
}
